import React from 'react';
import { useTranslation } from 'react-i18next';
import { Prize } from 'types/prizePool';
import styles from './prizePool.module.scss';

interface PrizePoolProps {
  prizePoolData?: Prize[];
}

const PrizePool: React.FC<PrizePoolProps> = ({ prizePoolData }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.prizePool}>
      <div className={styles.grid}>
        {prizePoolData?.map((prize: Prize) => (
          <div key={prize.id} className={styles.prizeItem}>
            <div className={styles.info}>
              <div className={styles.row}>
                <div className={styles.iconContainer}>
                  💰
                  {/* <img src={treasure} alt="case" className={styles.caseIcon} /> */}
                </div>
                <div className={styles.topRow}>
                  <span className={styles.label}>
                    {prize.label} {t('common.cash', 'Cash')}
                  </span>
                  <span className={styles.chance}>{prize.probability} %</span>
                </div>
              </div>
              <div className={styles.value}>${prize.amount}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrizePool;
